import { render } from "./journalManage.vue?vue&type=template&id=8ee81d06"
import script from "./journalManage.vue?vue&type=script&lang=js"
export * from "./journalManage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__